/**
 * Alpine.js Footer Language Picker Component
 *
 * Compact language picker for the minimal footer in the right sidebar.
 * Opens upward and saves the language preference via the settings API.
 */

/**
 * @param {string} initialLang - Current locale (e.g., 'en_US')
 * @param {Object} availableLanguages - Map of locale to language info
 * @returns {Object} Alpine.js component data
 */
export function footerLanguagePicker(initialLang, availableLanguages) {
    const languages = Object.entries(availableLanguages || {}).map(([locale, info]) => ({
        locale,
        name: info.name,
        native: info.native,
    }));

    return {
        selectedLang: initialLang || 'en_US',
        open: false,
        isSaving: false,
        languages,

        get currentLanguageLabel() {
            const lang = this.languages.find(l => l.locale === this.selectedLang);
            return lang ? lang.native : 'English';
        },

        toggle() {
            this.open = !this.open;
            if (this.open) {
                this.$nextTick(() => {
                    window.LucideIcons?.initialize(this.$el);
                });
            }
        },

        selectLang(locale) {
            if (locale === this.selectedLang) {
                this.open = false;
                return;
            }
            this.selectedLang = locale;
            this.open = false;
            this.saveLang();
        },

        saveLang() {
            const csrfToken = document.querySelector('meta[name="csrf_token"]')?.content ||
                             document.querySelector('input[name="csrf_token"]')?.value;
            if (!csrfToken) return;

            this.isSaving = true;

            const formData = new FormData();
            formData.append('field', 'lang');
            formData.append('value', this.selectedLang);
            formData.append('csrf_token', csrfToken);

            fetch('/app/settings/field/update', {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.reload();
                } else {
                    this.isSaving = false;
                }
            })
            .catch(() => {
                this.isSaving = false;
            });
        }
    };
}
